import classes from './Layout.module.scss';
import Footer from "../Footer/Footer";
import { Link } from 'react-router-dom';
import logo from '../../media/logo/logo.png';

const PublicLayout = (props) => {
    return (
        <div className={classes.layoutContainer}>
            <div className={classes.publicHeader}>
                <div className={classes.publicHeaderContent}>
                    <Link to="/">
                        <img src={logo} alt="Magic Motorsports" className={classes.logo} />
                    </Link>
                    <div className={classes.authButtons}>
                        <Link to="/login" className={classes.loginBtn}>Login</Link>
                        <Link to="/register" className={classes.registerBtn}>Register</Link>
                    </div>
                </div>
            </div>
            {props.children}
            <Footer />
        </div>
    )
}

export default PublicLayout;

